import React from "react";
import { Link } from "react-router-dom";
import { formatMXN } from "../lib/api";

export const ProductCard = ({ product, onAdd }) => {
  return (
    <div className="group" data-testid={`product-card-${product.slug}`}>
      <Link to={`/producto/${product.slug}`} className="block overflow-hidden bg-[#F2EFE9]">
        <div className="aspect-[3/4] overflow-hidden">
          <img
            src={product.images?.[0] || "https://images.pexels.com/photos/2887755/pexels-photo-2887755.jpeg"}
            alt={product.name}
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
        </div>
      </Link>
      <div className="pt-4 flex items-start justify-between gap-2">
        <div>
          <Link to={`/producto/${product.slug}`} className="block">
            <h3 className="font-serif text-xl leading-tight tracking-tight text-[#2C302E]">{product.name}</h3>
          </Link>
          <div className="mt-1 flex items-baseline gap-2">
            <span className="text-sm font-medium">{formatMXN(product.price)}</span>
            {product.compare_price && product.compare_price > product.price && (
              <span className="text-xs text-[#5B605E] line-through">{formatMXN(product.compare_price)}</span>
            )}
          </div>
        </div>
        {onAdd && (
          <button
            onClick={(e) => { e.preventDefault(); onAdd(product); }}
            className="text-xs uppercase tracking-wider link-underline"
            data-testid={`quick-add-${product.slug}`}
          >Añadir</button>
        )}
      </div>
    </div>
  );
};
